module.exports = __webpack_public_path__ + "img/w3_bookmark_grey.8e529317.png";